'use strict';

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

// 浏览器顶部设置
module.exports = {
	/**
  * @desc 唤起分享
  * @param {Object} params
  *      title     {String}    标题            必传
  *      content   {String}    内容            必传
  *      url       {String}    分享的url	     必传
  *      image     {String}    分享的缩略图地址  必传
  *      beauty    {Boolean}   是否有美图功能	 默认无
  */
	setShareData: function setShareData(params) {
		params.beauty = params.beauty ? 1 : 0;
		_jockey2.default.on("shareBridge", function (payload, complete) {
			complete(params);
		});
	},

	/**
  * @desc 分享调起
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  result	结果	int	0-成功 1-失败 2-取消 3-不支持
  */
	showSharePage: function showSharePage() {
		return new Promise(function (resolve) {
			_jockey2.default.send("H5ShareBridge", {}, function (res) {
				resolve(res);
			});
		});
	},

	/**
  * @desc 分享美图参数设置
  * @param {Object} params
  *      brand       {String}    品牌      必传
  *      series      {String}    车系      必传
  *      model       {String}    车型      必传
  *      price       {String}    价格      必传
  *      mile        {String}    里程      必传
  *      date        {String}    时间      必传
  *      imgs        {Array}     图片      必传
  *      carId       {String}    车辆Id    必传
  *      carUrl      {String}    车辆url   必传
  *      shopIcon    {String}    车店icon  必传
  *      avatarUrl   {String}    头像      必传
  *      clipboard   {String}    文案      必传，具体问产品
  */
	setShareBeautyData: function setShareBeautyData(params) {
		_jockey2.default.on("beautyBridge", function (payload, complete) {
			complete(params);
		});
	},

	/**
  * @desc 分享点击回调
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  回调是啥还不知道
  */
	setShareClickEvent: function setShareClickEvent(cb) {
		_jockey2.default.on("shareEventBridge", function (payload, complete) {
			cb && cb(payload.plat_form);
		});
	},

	/**
  * @desc 分享结果回调
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  回调是啥还不知道
  */
	setShareResultEvent: function setShareResultEvent(cb) {
		_jockey2.default.on("shareResultBridge", function (payload, complete) {
			cb && cb(payload.result);
		});
	},

	/**
  * @desc 分享结果回调
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  回调是啥还不知道
  */
	singleShare: function singleShare(params, cb) {
		_jockey2.default.send("H5SingleShareBridge", params, function (res) {
			cb && cb(res);
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/share.js
// module id = 271
// module chunks = 4